import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GeneralService } from 'src/services/general.service';
import { SweetAlertService } from 'src/services/sweet-alert.service';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subir-img-inicio',
  templateUrl: './subir-img-inicio.component.html',
  styleUrls: ['./subir-img-inicio.component.scss']
})
export class SubirImgInicioComponent {

  documentoForm = new FormGroup({
    ID: new FormControl(''),
    URL:new FormControl('')
  })

    //Variables para url de archivos
    urlDocumento = '';

    //Variables para indicar carga de archivos
    subiendoDocumento = false;

    data:any;

  constructor(private api: GeneralService, private alerts: SweetAlertService, private storage: Storage,private router: Router) { }

  ngOnInit(): void {


  }


}
